import React, { useMemo, useState } from "react";
import Viewer from "react-viewer";
import {
  convertStringToArray,
  extractDate,
  extractDateFromStr,
  getLatestUpdatedObject,
} from "../../../Utils/utils";
import Loader from "../../../components/Loader";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../../redux/services/apiSlice";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import { useTableResponsive } from "../../../hooks/useTableResponsive";
import PdfZipItem from "../../../components/PdfZipItem";
import { imageUrl } from "../../../constants/constants";

const RuralInfraCSR = () => {
  const { languageType } = useSelector((state) => state.homeSlice);
  const [visible, setVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);
  const openViewer = (images, index) => {
    setCurrentImages(
      images.map((img) => ({
        src: imageUrl + img.file_path,
        alt: img.title,
      })),
    );
    setActiveIndex(index);
    setVisible(true);
  };
  const { getText } = useLanguageTranslation();
  const {
    data: ruralInfrastructureData = [],
    isLoading: ruralInfrastructureIsLoading,
  } = useGetProtectedApiDataQuery({
    url: "rural_infrastructure",
    lang: languageType,
  });

  useTableResponsive(ruralInfrastructureData);

  const lastUpdatedOn = useMemo(() => {
    return extractDateFromStr(
      getLatestUpdatedObject(ruralInfrastructureData)?.changed,
    );
  }, [ruralInfrastructureData]);

  const pdfArray = convertStringToArray(
    ruralInfrastructureData[0]?.field_download,
  );

  const imagesArray = convertStringToArray(
    ruralInfrastructureData[0]?.field_events_image,
  );

  if (ruralInfrastructureIsLoading) {
    return (
      <div className="csr-loader">
        <Loader />;
      </div>
    );
  }

  return (
    <>
      {/* <!--content section start here--> */}
      <h2 className="title2">{ruralInfrastructureData[0]?.title}</h2>
      <div className="row">
        <div className="col-12 col-sm-12 col-md-2 col-lg-12 mt-4">
          <div className="title-sec">
            {/* <h4>Education</h4> */}
            <div className="table-responsive mb-5">
              <table className="table table-striped custom-table">
                <thead className="thead-dark">
                  <tr>
                    <th>{getText("S.No.", "क्र.सं.")}</th>
                    <th>{getText("Description", "विवरण")}</th>
                    <th>{getText("Download", "डाउनलोड")}</th>
                  </tr>
                </thead>
                <tbody>
                  {pdfArray?.map((item, index) => (
                    <tr key={index}>
                      <td data-key={getText("S.No.", "क्र. सं.")}>
                        {index + 1}
                      </td>
                      <td data-key={getText("Description", "विवरण")}>
                        {item.title}
                      </td>
                      <td data-key={getText("Download", "डाउनलोड")}>
                        <PdfZipItem filePath={item?.file_path} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className="title-sec">
          <h2>{getText("Photo Gallery", "फोटो गैलरी")}</h2>
        </div>
        <div className="row">
          {imagesArray?.map((photo, index) => (
            <div
              className="col-12 col-sm-12 col-md-4 col-lg-4 mb-4 print-gallery3"
              key={index}
            >
              <a onClick={() => openViewer(imagesArray, index)}>
                <div
                  className="card-sec wow zoomIn"
                  style={{
                    visibility: "visible",
                    animationName: "zoomIn",
                  }}
                >
                  <div className="img-sec">
                    <img
                      alt={
                        photo.title ||
                        getText("CSR activity photo", "सीएसआर गतिविधि की फोटो")
                      }
                      src={imageUrl + photo.file_path}
                    />
                  </div>
                  {/* <div className="desc-sec">
                  <div className="title-sec">
                    <h4>
                      <a href="javascript:void(0)">{photo.title}</a>
                    </h4>
                  </div>
                </div> */}
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
      <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />

      <Viewer
        visible={visible}
        onClose={() => setVisible(false)}
        onMaskClick={() => setVisible(false)}
        images={currentImages}
        activeIndex={activeIndex}
        rotatable={false}
        zoomable={true}
        scalable={false}
        drag={false}
      />
    </>
  );
};

export default RuralInfraCSR;
